import { LoggingService } from '@instinet-analytics/core-lib';
import {
    GetOrderColumnsMessage,
    OrderDataMessageDataItem,
} from 'communication/types/order/GetOrderColumnsMessage';

import { buildLogger, Logger } from '@instinet-analytics/core-lib';
import { OrdersMessageBatchBuffer } from './OrdersMessageBatchBuffer';
import { OrdersMessageIncrementalBuffer } from 'app/store/orders/OrdersMessageBuffer/OrdersMessageIncrementalBuffer';

import { processBatchedOrders } from 'app/store/orders/OrdersMessageBuffer/ordersMessageBatchProcessor';
import { IndigoStore } from 'store/store';

/*
 * Buffers order messages, switching between batch mode and incremental update mode as necessary
 */
export class OrdersMessageBufferService {
    private logger: Logger;
    private batchBuffer: OrdersMessageBatchBuffer | undefined = undefined;
    private incrementalBuffer: OrdersMessageIncrementalBuffer;
    public store: IndigoStore | undefined;

    public constructor(private loggingService: LoggingService) {
        this.incrementalBuffer = new OrdersMessageIncrementalBuffer(
            loggingService,
            (
                data: OrderDataMessageDataItem[],
                refreshDone: boolean,
                clearOrders: boolean
            ) => {
                this.output(data, refreshDone, clearOrders);
            }
        );
        this.logger = buildLogger('OrdersMessageBufferService', loggingService);
    }

    public in(message: GetOrderColumnsMessage) {
        if (!message) {
            return;
        }

        if (this.batchBuffer) {
            this.batchBuffer.in(message);
        } else {
            this.incrementalBuffer.in(message);
        }
    }

    public startNewBatch() {
        this.incrementalBuffer.flush();

        if (this.batchBuffer === undefined) {
            this.logger.debug('Starting new batch');

            this.batchBuffer = new OrdersMessageBatchBuffer(
                this.loggingService,
                (
                    data: OrderDataMessageDataItem[],
                    refreshDone: boolean,
                    clearOrders: boolean
                ) => {
                    this.outputBatch(data, refreshDone, clearOrders);
                }
            );
        }

        this.batchBuffer.startNewBatch();
    }

    private outputBatch(
        data: OrderDataMessageDataItem[],
        refreshDone: boolean,
        clearOrders: boolean
    ) {
        this.output(data, refreshDone, clearOrders);
        if (refreshDone) {
            this.logger.debug(
                'Batch complete, switching back to incremental updates...'
            );
            this.batchBuffer = undefined;
        }
    }

    private output(
        batch: OrderDataMessageDataItem[],
        refreshDone: boolean,
        clearOrders: boolean
    ) {
        processBatchedOrders(this.store!, batch, refreshDone, clearOrders);
    }
}
